import React from 'react'
function Meditation() {
  return (
    <>
   <h1 className='animalHeader'>Meditation and Breathing</h1>
    <div className='vidBorder'>
      <iframe 
      width="560" height="315" 
      src="https://www.youtube.com/embed/VUjiXcfKBn8 " 
      title="YouTube video player" 
      frameborder="0" 
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
      allowfullscreen>

      </iframe>
    </div>
 
    </>
  )
}
export default Meditation